import { OnboardingStep } from './OnboardingStep';

import type { OnboardingVariant } from '../deriveVariant';

const CONTACT_LAST = [
  OnboardingStep.AddVehicle,
  OnboardingStep.AddPayment,
  OnboardingStep.AddEmail,
] as const;

const CONTACT_FIRST = [
  OnboardingStep.AddEmail,
  OnboardingStep.AddVehicle,
  OnboardingStep.AddPayment,
] as const;

export function isContactCollectedLast({
  isNewAccount,
  variant,
}: {
  isNewAccount: boolean;
  variant: OnboardingVariant;
}): boolean {
  return isNewAccount && (variant === 'agnostic' || variant === 'locationSpecific');
}

export function stepOrderFor({
  isNewAccount,
  variant,
}: {
  isNewAccount: boolean;
  variant: OnboardingVariant;
}): readonly OnboardingStep[] {
  return isContactCollectedLast({ isNewAccount, variant }) ? CONTACT_LAST : CONTACT_FIRST;
}
